import validRole from "@/directive/security/validRole.js";
import validAuth from "@/directive/security/validAuth.js";


export default function directive(app){
  app.directive('auth', validAuth)
  app.directive('role', validRole)
}